/**
 * @flow
 * @relayHash d440e35c46bc309cee4a96db09ab3f02
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type profile_MutationVariables = {|
  profileInput: {
    first_name?: ?string,
    last_name?: ?string,
    email?: ?string,
    phone?: ?string,
    job_type_id?: ?string,
    company_size_id?: ?string,
    company_name?: ?string,
    industry_id?: ?string,
    opt_in_to_newsletter?: ?boolean,
    is_new_user?: ?boolean,
    ga_account_goal_sent?: ?boolean,
    clientMutationId?: ?string,
  },
|};
export type profile_MutationResponse = {|
  +updateProfile: ?{|
    +profile: ?{|
      +id: string,
      +user_id: string,
      +email: ?string,
      +external_provider: ?string,
      +first_name: ?string,
      +is_new_user: boolean,
      +ga_account_goal_sent: boolean,
      +last_name: ?string,
      +picture: ?string,
      +company_name: ?string,
      +company_size: ?{|
        +name: ?string,
      |},
      +industry: ?{|
        +name: ?string,
      |},
      +job_type: ?{|
        +name: ?string,
      |},
    |},
  |},
|};
*/


/*
mutation profile_Mutation(
  $profileInput: UpdateProfileInput!
) {
  updateProfile(input: $profileInput) {
    profile {
      id
      user_id
      email
      external_provider
      first_name
      is_new_user
      ga_account_goal_sent
      last_name
      picture
      company_name
      company_size {
        name
        id
      }
      industry {
        name
        id
      }
      job_type {
        name
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "profileInput",
    "type": "UpdateProfileInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "profileInput",
    "type": "UpdateProfileInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ga_account_goal_sent",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "external_provider",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_new_user",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_id",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "picture",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "company_name",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = [
  v12
],
v14 = [
  v12,
  v3
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "profile_Mutation",
  "id": null,
  "text": "mutation profile_Mutation(\n  $profileInput: UpdateProfileInput!\n) {\n  updateProfile(input: $profileInput) {\n    profile {\n      id\n      user_id\n      email\n      external_provider\n      first_name\n      is_new_user\n      ga_account_goal_sent\n      last_name\n      picture\n      company_name\n      company_size {\n        name\n        id\n      }\n      industry {\n        name\n        id\n      }\n      job_type {\n        name\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "profile_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProfile",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v13
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v13
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v13
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profile_Mutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateProfile",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v14
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v14
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v14
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '6c36db606619d593bbb4d539bc0a64d7';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/profile_Mutation.graphql.js